"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeys = exports.getStringKeys = void 0;
/* eslint-disable @typescript-eslint/ban-types */
/**
 * Object.keys for string keys only
 * @param o - The object to get the keys from
 * @returns The string keys of the object preserving type
 */
function getStringKeys(o) {
    return Object.keys(o).filter((k) => typeof k === 'string');
}
exports.getStringKeys = getStringKeys;
/**
 * Object.keys that actually preserves keys as types.
 * @param o - The object to get the keys from
 * @returns The keys of the object preserving type
 */
function getKeys(o) {
    return Object.keys(o);
}
exports.getKeys = getKeys;
/* eslint-enable @typescript-eslint/ban-types */
//# sourceMappingURL=getKeys.js.map